"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["className", "classes"];
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  const {
    spacing
  } = theme.busbud;
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto',
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      overflowY: 'auto',
      padding: spacing(3, 3.5, 0),
      '&:first-child': {
        // dialog without title
        paddingTop: spacing(3)
      },
      '&:after': {
        // fix for FF issue on scrollable content
        content: "''",
        display: 'block',
        paddingBottom: spacing(3.5)
      }
    }
  };
});
/**
 * DialogContent is a wrapper used to style the content inside a `Dialog` component.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-api-dialogcontent--page)
 */
const DialogContent = /*#__PURE__*/_react.default.forwardRef(function DialogContent(props, ref) {
  const {
      className,
      classes: classesOverrides
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: cx(classes.root, className),
    ref: ref
  }, other));
});
var _default = exports.default = DialogContent;